module.exports = __webpack_public_path__ + "assets/img/biao2.6a7c6d0d.png";